import type { ReactElement } from 'react'

import { type TypeVariationContainerAuthAndDeviceTypeCtaEntry } from '@contentful-types/index'

import { useGetAuthAndDeviceTypeCta } from '../../lib/hooks/auth-and-device-type-cta'
import { ContentRenderer } from '../renderer'

export function AuthAndDeviceTypeCtaVariationContainer({
  data,
}: {
  data: TypeVariationContainerAuthAndDeviceTypeCtaEntry
}): ReactElement {
  const { getAuthAndDeviceTypeCta } = useGetAuthAndDeviceTypeCta()

  return <ContentRenderer data={getAuthAndDeviceTypeCta(data)} />
}
